import { SVGProps } from "react";
const CalendarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    viewBox="0 0 19 18"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1640_68924)">
      <path
        d="M14.75 1.5H14V0.75C14 0.551088 13.921 0.360322 13.7803 0.21967C13.6397 0.0790176 13.4489 0 13.25 0C13.0511 0 12.8603 0.0790176 12.7197 0.21967C12.579 0.360322 12.5 0.551088 12.5 0.75V1.5H6.5V0.75C6.5 0.551088 6.42098 0.360322 6.28033 0.21967C6.13968 0.0790176 5.94891 0 5.75 0C5.55109 0 5.36032 0.0790176 5.21967 0.21967C5.07902 0.360322 5 0.551088 5 0.75V1.5H4.25C3.2558 1.50119 2.30267 1.89666 1.59966 2.59966C0.896661 3.30267 0.501191 4.2558 0.5 5.25L0.5 14.25C0.501191 15.2442 0.896661 16.1973 1.59966 16.9003C2.30267 17.6033 3.2558 17.9988 4.25 18H14.75C15.7442 17.9988 16.6973 17.6033 17.4003 16.9003C18.1033 16.1973 18.4988 15.2442 18.5 14.25V5.25C18.4988 4.2558 18.1033 3.30267 17.4003 2.59966C16.6973 1.89666 15.7442 1.50119 14.75 1.5ZM2 5.25C2 4.65326 2.23705 4.08097 2.65901 3.65901C3.08097 3.23705 3.65326 3 4.25 3H14.75C15.3467 3 15.919 3.23705 16.341 3.65901C16.7629 4.08097 17 4.65326 17 5.25V6H2V5.25ZM14.75 16.5H4.25C3.65326 16.5 3.08097 16.2629 2.65901 15.841C2.23705 15.419 2 14.8467 2 14.25V7.5H17V14.25C17 14.8467 16.7629 15.419 16.341 15.841C15.919 16.2629 15.3467 16.5 14.75 16.5Z"
        fill="#5D626C"
      />
      <path
        d="M9.5 12.375C10.1213 12.375 10.625 11.8713 10.625 11.25C10.625 10.6287 10.1213 10.125 9.5 10.125C8.87868 10.125 8.375 10.6287 8.375 11.25C8.375 11.8713 8.87868 12.375 9.5 12.375Z"
        fill="#5D626C"
      />
      <path
        d="M5.75 12.375C6.37132 12.375 6.875 11.8713 6.875 11.25C6.875 10.6287 6.37132 10.125 5.75 10.125C5.12868 10.125 4.625 10.6287 4.625 11.25C4.625 11.8713 5.12868 12.375 5.75 12.375Z"
        fill="#5D626C"
      />
      <path
        d="M13.25 12.375C13.8713 12.375 14.375 11.8713 14.375 11.25C14.375 10.6287 13.8713 10.125 13.25 10.125C12.6287 10.125 12.125 10.6287 12.125 11.25C12.125 11.8713 12.6287 12.375 13.25 12.375Z"
        fill="#5D626C"
      />
    </g>
    <defs>
      <clipPath id="clip0_1640_68924">
        <rect width={18} height={18} fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);
export default CalendarIcon;
